// Configuración y utilidades del módulo de Leads (sin React).

// Fase de pruebas (desactivada el 2026-10-30 a petición del usuario: todos los leads pasan a ser reales). Mientras sea true, los leads nuevos se marcan "de prueba" por defecto y se
// muestra un aviso para no introducir datos reales. Pasarlo a false es decisión del usuario.
export const LEADS_TEST_MODE = false;

// Avisos visuales del modo pruebas (banner amarillo y etiqueta 🧪 PRUEBA). Ocultos desde el 2026-10-29 por decisión del
// usuario: los leads siguen marcándose como prueba (fuera de las métricas por defecto y con 🧪 en los correos).
export const LEADS_TEST_VISUALS = false;

// IA (Fase 6: leer fichas con IA y perfil del cliente). En pausa mientras se monta la entrada automática desde el
// CRM (decisión del 2026-10-27): los botones se ocultan; las Edge Functions siguen desplegadas.
export const LEADS_AI_ENABLED = false;

// Agente de seguimiento por WhatsApp: desarrollado pero APAGADO (decisión del 2026-11-03, pendiente de acuerdo con el
// concesionario). Con `false` no se muestra nada ni se consultan sus tablas, que aún no existen en producción.
// Para activarlo: docs/AGENTE-WHATSAPP.md.
export const WA_AGENT_ENABLED = false;

// Punto de entrada de los leads online (Edge Function ingest-lead, autenticada con una clave de conexión).
export const INGEST_URL = 'https://dabyiebqjiporyuxqlbf.supabase.co/functions/v1/ingest-lead';

// Roles que supervisan (ven todo, asignan, gestionan accesos). Mismos que ADMIN_TIER_ROLES de App.js.
export const LEAD_SUPERVISOR_ROLES = ['creador', 'responsable'];
// Roles que pueden registrar leads (además, la base de datos exige tener el panel activado).
export const LEAD_CREATE_ROLES = ['creador', 'responsable', 'comercial'];

export const LEAD_STATUSES = [
  { key: 'sin_asignar', label: 'Sin asignar', bg: 'var(--b-374151)', fg: 'var(--t-d1d5db)' },
  { key: 'asignado', label: 'Asignado', bg: 'var(--b-1e3a8a)', fg: 'var(--t-bfdbfe)' },
  { key: 'contactado', label: 'Contactado', bg: 'var(--b-1e40af)', fg: 'var(--t-93c5fd)' },
  { key: 'en_conversacion', label: 'En conversación', bg: 'var(--b-4c1d95)', fg: 'var(--t-ddd6fe)' },
  { key: 'cita_agendada', label: 'Cita agendada', bg: 'var(--b-581c87)', fg: 'var(--t-e9d5ff)' },
  { key: 'visita_realizada', label: 'Visita realizada', bg: 'var(--b-78350f)', fg: 'var(--t-fde68a)' },
  { key: 'reservado', label: 'Reservado', bg: 'var(--b-166534)', fg: 'var(--t-bbf7d0)' },
  { key: 'vendido', label: 'Vendido', bg: 'var(--b-14532d)', fg: 'var(--t-4ade80)' },
  { key: 'perdido', label: 'Perdido', bg: 'var(--b-7f1d1d)', fg: 'var(--t-fecaca)' },
  { key: 'descartado', label: 'Descartado', bg: 'var(--b-1f2937)', fg: 'var(--t-9ca3af)' }
];
export const OPEN_STATUSES = LEAD_STATUSES.map(s => s.key).filter(k => !['vendido', 'perdido', 'descartado'].includes(k));

// Lead del CRM creado por otra persona (originador que no empieza por "API", p. ej. "API" o "API Automática CRM"):
// posiblemente ya lo atiende alguien. Misma regla que lead_possibly_attended en la base de datos.
export function possiblyAttended(lead) {
  const o = String((lead && lead.crm_originator) || '').trim();
  return !!o && !o.toUpperCase().startsWith('API');
}

export const NO_CONTACT_DISCARD_REASON = 'Sin datos de contacto o son incorrectos';
export const DISCARD_REASONS = ['Ya atendido por otra persona', NO_CONTACT_DISCARD_REASON, 'Duplicado', 'No es de esta tienda', 'Prueba o error'];

// Quién puede descartar (igual que la función discard_lead): supervisores; comerciales en sus leads o en la Bandeja si pueden coger.
export function canDiscard(lead, access, userId) {
  if (!lead || !OPEN_STATUSES.includes(lead.status) || !access || !access.ok) return false;
  if (access.supervisor) return true;
  return lead.assigned_to === userId || (!lead.assigned_to && access.can_claim);
}
export const statusInfo = (key) => LEAD_STATUSES.find(s => s.key === key) || LEAD_STATUSES[0];

export const TEMPERATURES = [
  { key: 'frio', label: '❄️ Frío', color: 'var(--t-93c5fd)' },
  { key: 'templado', label: '🌤️ Templado', color: 'var(--t-fde68a)' },
  { key: 'caliente', label: '🔥 Caliente', color: 'var(--t-fca5a5)' }
];
export const temperatureInfo = (key) => TEMPERATURES.find(t => t.key === key) || TEMPERATURES[1];

export const INTERACTION_TYPES = [
  { key: 'llamada', label: '📞 Llamada' },
  { key: 'whatsapp', label: '💬 WhatsApp' },
  { key: 'email', label: '✉️ Email' },
  { key: 'visita', label: '🏪 Visita' },
  { key: 'nota', label: '📝 Nota' }
];
export const OUTCOME_SUGGESTIONS = ['No contesta', 'Interesado', 'Pide más información', 'Cita agendada', 'Lo pensará', 'No interesado'];

// Columnas que se leen de la tabla leads (nunca select('*')).
export const LEAD_COLUMNS = 'id, org_id, source, channel, crm_lead_id, crm_url, received_at, created_at, created_by, customer_name, phone, phone_e164, email, city, customer_message, vehicle_text, vehicle_plate, vehicle_ref, vehicle_price, vehicle_price_financed, vehicle_id, status, temperature, lost_reason, assigned_to, assigned_by, assigned_at, first_assigned_at, first_contact_at, last_contact_at, contact_count, next_followup, reserved_at, closed_at, notes, is_test, crm_originator, discarded_at, discarded_by, discard_reason, appointment_at, appointment_reminded_at, updated_at';

// Canal: online = entra solo desde el CRM (o lo registra un supervisor); presencial = cliente en tienda;
// telefono = cliente que llama a la tienda (los dos últimos los crea un usuario a mano).
export const LEAD_CHANNELS = [
  { key: 'online', label: 'Online', icon: '🌐' },
  { key: 'presencial', label: 'Presencial', icon: '🏪' },
  { key: 'telefono', label: 'Llamada a tienda', icon: '📞' }
];
// La "primera llamada" obligatoria solo tiene sentido en los leads online: en los presenciales y en las llamadas a
// tienda el primer contacto ya ha ocurrido (en persona o por teléfono).
export const needsFirstCall = (lead) => !!lead && lead.channel === 'online';
export function channelInfo(key) {
  return LEAD_CHANNELS.find(c => c.key === key) || LEAD_CHANNELS[1];
}

// ---------- Fechas ----------

export function timeAgo(iso, now = Date.now()) {
  if (!iso) return '';
  const min = Math.max(0, Math.round((now - new Date(iso).getTime()) / 60000));
  if (min < 1) return 'ahora mismo';
  if (min < 60) return `hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `hace ${h} h${min % 60 ? ` ${min % 60} min` : ''}`;
  const d = Math.floor(h / 24);
  return `hace ${d} día${d === 1 ? '' : 's'}`;
}

export function formatDateTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

// 'YYYY-MM-DD' de hoy en hora local.
export function todayStr(offsetDays = 0) {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function formatDay(dateStr) {
  if (!dateStr) return '—';
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('es-ES', { weekday: 'short', day: '2-digit', month: '2-digit' });
}

// Valor para <input type="datetime-local"> (hora local).
export function toLocalInput(date) {
  const d = new Date(date);
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

// Semáforo del próximo seguimiento: rojo vencido, ámbar hoy, verde futuro, gris sin fecha.
export function followupState(lead) {
  if (!lead.next_followup || !OPEN_STATUSES.includes(lead.status)) return { key: 'none', color: 'var(--t-6b7280)', label: 'Sin seguimiento' };
  const today = todayStr();
  if (lead.next_followup < today) return { key: 'late', color: 'var(--t-f87171)', label: `Vencido (${formatDay(lead.next_followup)})` };
  if (lead.next_followup === today) return { key: 'today', color: 'var(--t-fbbf24)', label: 'Seguimiento hoy' };
  return { key: 'ok', color: 'var(--t-4ade80)', label: `Seguimiento ${formatDay(lead.next_followup)}` };
}

export function daysWithoutContact(lead) {
  const ref = lead.last_contact_at || lead.received_at;
  if (!ref) return null;
  return Math.floor((Date.now() - new Date(ref).getTime()) / 86400000);
}

// ---------- Contacto ----------

export function whatsappUrl(lead, text) {
  const digits = (lead.phone_e164 || '').replace(/[^0-9]/g, '');
  if (!digits) return null;
  return `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}

// Email válido del cliente o null.
export function leadEmail(lead) {
  const e = String((lead && lead.email) || '').trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e) ? e : null;
}

// Correo nuevo en Gmail (navegador) con destinatario, asunto y texto ya rellenos.
export function gmailComposeUrl(lead, subject, body) {
  const e = leadEmail(lead);
  if (!e) return null;
  const q = [`to=${encodeURIComponent(e)}`];
  if (subject) q.push(`su=${encodeURIComponent(subject)}`);
  if (body) q.push(`body=${encodeURIComponent(body)}`);
  return `https://mail.google.com/mail/?view=cm&fs=1&${q.join('&')}`;
}

// Resultados de la primera llamada cuando se ha hablado con el cliente.
export const FIRST_CALL_OUTCOMES = ['Interesado', 'Pide más información', 'Cita agendada', 'Lo pensará', 'No interesado'];
export const APPOINTMENT_OUTCOME = 'Cita agendada';

// Siguiente día de tienda (sin domingos) en 'YYYY-MM-DD', como lead_next_open_day en la base de datos.
export function nextOpenDayStr() {
  const d = new Date();
  d.setDate(d.getDate() + (d.getDay() === 6 ? 2 : 1));
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Nombre real del cliente (los leads en modo ensayo llegan como «Cliente CRM 123»).
export function realCustomerName(lead) {
  const n = String((lead && lead.customer_name) || '').trim();
  return !n || /^cliente crm\b/i.test(n) ? '' : n.split(/\s+/)[0];
}

// Mensaje de presentación para el cliente al que no se ha podido llamar (WhatsApp o correo).
export function presentationMessage(lead, userName, storeName) {
  const name = realCustomerName(lead);
  const me = String(userName || '').trim() || 'tu asesor comercial';
  const store = String(storeName || '').trim();
  const car = String(lead.vehicle_text || '').trim();
  const url = isHttpUrl(lead.vehicle_ref) ? lead.vehicle_ref : '';
  const lines = [
    `Hola${name ? ` ${name}` : ''}, soy ${me}${store ? `, de ${store}` : ''}.`,
    `Te escribo porque nos has pedido información sobre ${car ? `el ${car}` : 'uno de nuestros coches'}${url ? `:\n${url}` : '.'}`,
    'He intentado llamarte, pero no he podido hablar contigo. Estaré encantado de resolver tus dudas, contarte las opciones de financiación y garantía, o reservarte una cita para verlo y probarlo.',
    '¿Cuándo te viene bien que hablemos?',
    `Un saludo,\n${me}${store ? `\n${store}` : ''}`
  ];
  return {
    subject: `${car ? `${car} — ` : ''}tu solicitud de información${store ? ` en ${store}` : ''}`,
    body: lines.join('\n\n')
  };
}

// Cita futura del lead (Date) o null.
export function upcomingAppointment(lead) {
  if (!lead || !lead.appointment_at || !OPEN_STATUSES.includes(lead.status)) return null;
  const d = new Date(lead.appointment_at);
  return d.getTime() > Date.now() - 3600000 ? d : null;
}

export function formatAppointment(date) {
  return new Date(date).toLocaleString('es-ES', { weekday: 'long', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export function telUrl(lead) {
  const t = (lead.phone_e164 || lead.phone || '').replace(/[^0-9+]/g, '');
  return t ? `tel:${t}` : null;
}

// Nombre de la columna del coche de stock vinculado (vehicle_id) o null.
export function stockLabel(lead, vehicles, columns) {
  if (!lead.vehicle_id) return null;
  const v = (vehicles || []).find(x => x.id === lead.vehicle_id);
  if (!v) return null;
  return (columns || []).find(c => c.id === v.column_id)?.label || null;
}

export function normalizePlate(p) {
  return (p || '').toUpperCase().replace(/[\s-]/g, '');
}

// Mensaje de error de Supabase legible.
export function rpcError(error) {
  if (!error) return '';
  return (error.message || String(error)).replace(/^.*?ERROR:\s*/, '');
}

// ---------- Lectura de la ficha pegada del CRM ----------

const strip = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

// Etiquetas que suelen aparecer en una ficha de lead (sin tildes, en minúsculas). El orden importa:
// las más específicas primero ("id lead" antes que "id", "precio" antes que "coche").
const LABELS = [
  ['crm_lead_id', ['id lead', 'id del lead', 'lead id', 'n lead', 'no lead', 'num lead', 'numero lead', 'numero de lead', 'id oportunidad', 'id solicitud', 'referencia lead', 'ref lead', 'id contacto']],
  ['received_at', ['fecha de entrada', 'fecha entrada', 'fecha de alta', 'fecha alta', 'fecha de creacion', 'fecha creacion', 'fecha del lead', 'recibido', 'fecha']],
  ['customer_name', ['nombre y apellidos', 'nombre completo', 'nombre del cliente', 'cliente', 'nombre', 'contacto', 'interesado']],
  ['phone', ['telefono movil', 'telefono', 'movil', 'tlf', 'tel', 'celular', 'whatsapp']],
  ['email', ['correo electronico', 'e-mail', 'email', 'correo', 'mail']],
  ['city', ['localidad', 'poblacion', 'ciudad', 'municipio', 'provincia', 'codigo postal', 'cp']],
  ['vehicle_plate', ['matricula']],
  ['vehicle_ref', ['enlace del anuncio', 'enlace anuncio', 'url del anuncio', 'url anuncio', 'link anuncio', 'anuncio', 'enlace web', 'web']],
  ['crm_url', ['enlace crm', 'url crm', 'enlace del lead', 'url del lead']],
  ['vehicle_price_financed', ['precio financiado', 'pvp financiado', 'financiado']],
  ['vehicle_price', ['precio contado', 'precio al contado', 'precio', 'pvp', 'importe']],
  ['vehicle_text', ['vehiculo de interes', 'vehiculo', 'coche', 'modelo', 'version', 'marca y modelo']],
  ['customer_message', ['mensaje', 'comentario', 'comentarios', 'observaciones', 'consulta', 'texto']]
];

function labelKey(label, exact = false) {
  const l = strip(label).replace(/[.#º°ª]/g, '').replace(/\s+/g, ' ');
  if (!l || l.length > 40) return null;
  for (const [key, names] of LABELS) {
    if (names.some(n => l === n || (!exact && (l.startsWith(n + ' ') || l.endsWith(' ' + n))))) return key;
  }
  return null;
}

const PHONE_RE = /(?:\+|00)?(?:34[\s.-]*)?[6789](?:[\s.-]*\d){8}\b/;
const EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
// Matrícula actual (0000 BBB). Con etiqueta "Matrícula" se acepta en minúsculas; suelta en el texto, solo en
// mayúsculas y en la misma línea (para no confundir "2019" + "PVP" de dos líneas seguidas).
const PLATE_LABELED_RE = /\b(\d{4})[ \t-]?([BCDFGHJKLMNPRSTVWXYZ]{3})\b/i;
const PLATE_RE = /\b(\d{4})[ \t-]?([BCDFGHJKLMNPRSTVWXYZ]{3})\b/;
const URL_RE = /https?:\/\/[^\s<>"']+/i;
const PRICE_RE = /(\d{1,3}(?:[.\s]\d{3})+|\d{4,6})(?:,\d{1,2})?\s*(?:€|eur\b|euros\b)/i;

function parsePrice(text) {
  const m = String(text).match(/(\d{1,3}(?:[.\s]\d{3})+|\d+)(?:,(\d{1,2}))?/);
  if (!m) return null;
  const n = Number(m[1].replace(/[.\s]/g, '') + (m[2] ? '.' + m[2] : ''));
  return Number.isFinite(n) && n >= 500 && n < 1000000 ? n : null;
}

// "27/10/2026 10:35", "27-10-26 10:35", "2026-10-27 10:35"
function parseDate(text) {
  let m = String(text).match(/(\d{1,2})[/.-](\d{1,2})[/.-](\d{2,4})(?:[^\d]+(\d{1,2})[:h.](\d{2}))?/);
  let y, mo, d, h = 0, mi = 0;
  if (m) {
    d = +m[1]; mo = +m[2]; y = +m[3]; if (y < 100) y += 2000;
    if (m[4]) { h = +m[4]; mi = +m[5]; }
  } else {
    m = String(text).match(/(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}))?/);
    if (!m) return null;
    y = +m[1]; mo = +m[2]; d = +m[3];
    if (m[4]) { h = +m[4]; mi = +m[5]; }
  }
  const dt = new Date(y, mo - 1, d, h, mi);
  if (Number.isNaN(dt.getTime()) || dt.getMonth() !== mo - 1) return null;
  return dt;
}

// Extrae los datos de un lead del texto copiado de la ficha del CRM (o de un correo).
// No inventa nada: solo devuelve lo que encuentra. Devuelve { fields, found: [claves] }.
// Dominios de la web pública de los anuncios (el enlace del coche); cualquier otro enlace se toma como el del CRM.
export const WEB_AD_HOSTS = ['flexicar.es'];
export const isHttpUrl = (u) => /^https?:\/\/\S+$/i.test(String(u || '').trim());
function isWebAdUrl(u) {
  try {
    const h = new URL(u).hostname.toLowerCase();
    return WEB_AD_HOSTS.some(d => (h === d || h.endsWith('.' + d))) && !/(^|\.)crm\.|crm/.test(h);
  } catch (e) { return false; }
}

// Guarda un valor ya etiquetado en su campo, validándolo según el tipo. Devuelve true si lo guarda.
function putField(fields, key, rawValue) {
  const value = String(rawValue || '').trim();
  if (!value || fields[key] != null) return false;
  if (key === 'vehicle_price' || key === 'vehicle_price_financed') { const p = parsePrice(value); if (p == null) return false; fields[key] = p; return true; }
  if (key === 'received_at') { const d = parseDate(value); if (!d) return false; fields.received_at = d; return true; }
  if (key === 'phone') { const p = value.match(PHONE_RE); if (!p) return false; fields.phone = p[0].trim(); return true; }
  if (key === 'email') { const e = value.match(EMAIL_RE); if (!e) return false; fields.email = e[0]; return true; }
  if (key === 'vehicle_plate') {
    const p = value.match(PLATE_LABELED_RE);
    fields.vehicle_plate = p ? `${p[1]}${p[2].toUpperCase()}` : value.toUpperCase().slice(0, 15);
    return true;
  }
  if (key === 'vehicle_ref' || key === 'crm_url') { const u = value.match(URL_RE); if (!u) return false; fields[key] = u[0].replace(/[).,;]+$/, ''); return true; }
  if (key === 'customer_name' && (EMAIL_RE.test(value) || PHONE_RE.test(value))) return false;
  fields[key] = value.slice(0, 500);
  return true;
}

// Campos que se aceptan sin dos puntos ("Teléfono 600 123 456"): los de forma reconocible y el nombre/localidad sin cifras.
const TYPED_KEYS = ['phone', 'email', 'vehicle_price', 'vehicle_price_financed', 'vehicle_plate', 'received_at', 'vehicle_ref', 'crm_url'];
const NO_COLON_TEXT_KEYS = ['customer_name', 'city'];

// Extrae los datos de un lead del texto copiado de la ficha del CRM (o de un correo).
// No inventa nada: solo devuelve lo que encuentra. Devuelve { fields, found: [claves] }.
// Formatos que entiende: "Etiqueta: valor", etiqueta y valor en líneas seguidas, celdas separadas por
// tabuladores (en la misma fila o una fila de títulos y otra de valores) y "Teléfono 600 123 456" sin dos puntos.
// ---------- Ficha de lead del CRM de Flexicar ("Flexicar | Lead de Venta") ----------
// Etiquetas en mayúsculas seguidas del valor en la misma línea ("TELF. PRINCIPAL 600123456"); a veces el
// valor va en la línea siguiente (al copiar desde el navegador). Las más largas primero ("PRECIO CONTADO").
const FX_LABELS = [
  'NOMBRE', 'APELLIDOS', 'TELF. PRINCIPAL', 'TELF. SECUNDARIO', 'EMAIL', 'FECHA ALTA', 'PROVINCIA', 'POBLACIÓN',
  'RECIBIR PUBLICIDAD', 'QUIERE FINANCIAR', 'ÚLTIMO INTERÉS', 'ÚLTIMA MODIFICACIÓN', 'LEAD ANTERIOR', 'DÍAS EN STOCK',
  'EMPRESA STOCK', 'STOCK DIRIGIDO A', 'MATRÍCULA', 'MARCA', 'MODELO', 'MODEL', 'VERSIÓN', 'PRECIO CONTADO', 'PRECIO FINANCIADO', 'PRECIO',
  'SEDE', 'CARROCERÍA', 'AÑO', 'KILÓMETROS', 'TRANSMISIÓN', 'COMBUSTIBLE', 'ESTADO', 'ACEPTA TYC', 'RECIBIR INFO',
  'ORIGINADOR', 'PROCEDENCIA', 'CONTACTO VÍA', 'AGENTE'
].sort((a, b) => b.length - a.length);
const FX_SECTIONS = ['Datos personales', 'Lead', 'Imagen', 'Información del Cliente', 'Datos del Vehículo', 'Acciones sobre el Lead',
  'Información sobre el Lead', 'Otros leads', 'Crear Propuesta Comercial', 'Reservar', 'Citar', 'No financiable', 'Seleccionar cita', 'Cita confirmada'];
// Etiquetas cuyo valor puede venir en la línea siguiente.
const FX_NEXT_LINE = ['NOMBRE', 'APELLIDOS', 'TELF. PRINCIPAL', 'TELF. SECUNDARIO', 'EMAIL', 'POBLACIÓN', 'PROVINCIA', 'QUIERE FINANCIAR',
  'MATRÍCULA', 'MARCA', 'MODELO', 'MODEL', 'VERSIÓN', 'PRECIO', 'PRECIO CONTADO', 'PRECIO FINANCIADO', 'AÑO', 'KILÓMETROS', 'PROCEDENCIA', 'CONTACTO VÍA', 'AGENTE', 'SEDE'];

export function isFlexicarLeadText(text) {
  return /TELF\. PRINCIPAL/.test(text) || (/Datos personales/.test(text) && /Datos del Veh[ií]culo/.test(text));
}

const fxLabelOf = (line) => FX_LABELS.find(l => line === l || line.startsWith(l + ' ') || line.startsWith(l + '\t') || line.startsWith(l + ':'));
const fxIsBoundary = (line) => !!fxLabelOf(line) || FX_SECTIONS.includes(line);

const fxWords = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
  .replace(/[…]|\.\.\./g, ' ').split(/[^a-z0-9]+/).filter(Boolean);
function fxDateTime(t) {
  const m = String(t || '').match(/(\d{1,2})-(\d{1,2})-(\d{4})\s+(\d{1,2}):(\d{2})/);
  if (!m) return null;
  const d = new Date(+m[3], +m[2] - 1, +m[1], +m[4], +m[5]);
  return Number.isNaN(d.getTime()) ? null : d;
}
// Columnas de "Otros leads": del PDF (líneas "OTRO LEAD\t…", ver pdfText.js) o de una tabla pegada con tabuladores,
// ya sea girada (filas "Fecha Creación\t…", "Vehículo\t…", "Precio\t…") o normal (cabecera y una fila por lead).
function otherLeadsFrom(lines) {
  const fromPdf = lines.filter(l => l.startsWith('OTRO LEAD\t')).map(l => {
    const get = (k) => ((l.split('\t').find(c => c.startsWith(k + '=')) || '').slice(k.length + 1));
    return { created: get('FECHA CREACIÓN'), vehicle: get('VEHÍCULO'), price: get('PRECIO') };
  });
  if (fromPdf.length) return fromPdf;
  const row = (re) => lines.find(l => re.test(l) && l.includes('\t'));
  const fc = row(/^Fecha Creaci[oó]n\t/); const ve = row(/^Veh[ií]culo\t/); const pr = row(/^Precio\t/);
  if (fc && ve && pr) {
    const [a, b, c] = [fc, ve, pr].map(r => r.split('\t').slice(1).map(x => x.trim()));
    if (a.length === b.length && b.length === c.length) return a.map((x, i) => ({ created: x, vehicle: b[i], price: c[i] }));
  }
  const hi = lines.findIndex(l => /Fecha Creaci[oó]n/.test(l) && /Veh[ií]culo/.test(l) && /Precio/.test(l) && l.includes('\t'));
  if (hi >= 0) {
    const head = lines[hi].split('\t').map(x => x.trim());
    const iF = head.findIndex(h => /^Fecha Creaci/.test(h)); const iV = head.findIndex(h => /^Veh/.test(h)); const iP = head.findIndex(h => /^Precio/.test(h));
    const out = [];
    for (let i = hi + 1; i < lines.length; i++) {
      const c = lines[i].split('\t');
      if (c.length !== head.length) break;
      out.push({ created: c[iF], vehicle: c[iV], price: c[iP] });
    }
    return out;
  }
  return [];
}

export function parseFlexicarLead(raw) {
  const lines = String(raw || '').replace(/\r/g, '').replace(/ /g, ' ').split('\n').map(l => l.trim()).filter(Boolean);
  const v = {};
  for (let i = 0; i < lines.length; i++) {
    const label = fxLabelOf(lines[i]);
    if (!label || v[label] != null) continue;
    let value = lines[i].slice(label.length).replace(/^[:\s]+/, '').trim();
    if (!value && FX_NEXT_LINE.includes(label) && i + 1 < lines.length && !fxIsBoundary(lines[i + 1])) { value = lines[i + 1]; i++; }
    v[label] = value;
  }
  const fields = {};
  const put = (k, val) => { if (val != null && String(val).trim() !== '') fields[k] = typeof val === 'string' ? val.trim().slice(0, 500) : val; };

  put('customer_name', [v.NOMBRE, v.APELLIDOS].filter(Boolean).join(' '));
  const phone = [v['TELF. PRINCIPAL'], v['TELF. SECUNDARIO']].map(t => (t || '').match(PHONE_RE)).find(Boolean);
  put('phone', phone ? phone[0] : (v['TELF. PRINCIPAL'] || ''));
  const email = (v.EMAIL || '').match(EMAIL_RE);
  if (email) put('email', email[0]);
  put('city', v['POBLACIÓN'] || v.PROVINCIA);
  const plate = (v['MATRÍCULA'] || '').match(PLATE_LABELED_RE);
  put('vehicle_plate', plate ? `${plate[1]}${plate[2].toUpperCase()}` : (v['MATRÍCULA'] || '').toUpperCase().replace(/[\s-]/g, ''));
  const model = v.MODEL || v.MODELO;
  const year = (v['AÑO'] || '').match(/\d{4}/);
  put('vehicle_text', [v.MARCA, model, v['VERSIÓN']].filter(Boolean).join(' ') + (year && (v.MARCA || model) ? ` (${year[0]})` : ''));
  // En la ficha de Flexicar, "PRECIO" es el precio financiado y "PRECIO CONTADO" el de al contado.
  const cash = parsePrice(v['PRECIO CONTADO'] || '');
  const financed = parsePrice(v['PRECIO FINANCIADO'] || v.PRECIO || '');
  if (cash != null) put('vehicle_price', cash);
  if (financed != null) put('vehicle_price_financed', financed);

  // Mensaje del cliente: lo que hay entre "Información del Cliente" y la sección siguiente.
  const from = lines.indexOf('Información del Cliente');
  if (from >= 0) {
    const msg = [];
    for (let i = from + 1; i < lines.length && !fxIsBoundary(lines[i]); i++) msg.push(lines[i]);
    put('customer_message', msg.join('\n'));
  }

  // Hora de entrada: la "Fecha Creación" de la columna de "Otros leads" cuyo vehículo y precio coinciden con
  // "Datos del Vehículo" (la primera columna no siempre es este lead). Si coinciden varias, la más reciente
  // con hora completa. Si la que coincide no muestra la hora (columna estrecha), no se rellena y se avisa.
  const warnings = [];
  const others = otherLeadsFrom(lines);
  if (others.length) {
    const carWords = fxWords([v.MARCA, model].filter(Boolean).join(' '));
    const myPrices = [financed, cash].filter(p => p != null);
    const matches = others.filter(o => {
      const w = fxWords(o.vehicle);
      const sameCar = w.length > 0 && carWords.length > 0 && w.every(x => carWords.includes(x)) && w.includes(carWords[0]);
      return sameCar && myPrices.includes(parsePrice(o.price));
    });
    const withTime = matches.map(o => ({ o, d: fxDateTime(o.created) })).filter(m => m.d);
    if (withTime.length) fields.received_at = withTime.sort((a, b) => b.d - a.d)[0].d;
    else if (matches.length) warnings.push('El lead aparece en "Otros leads" pero sin la hora de creación: indica la hora de entrada a mano.');
    else warnings.push('No se ha encontrado este lead en "Otros leads": indica la hora de entrada a mano.');
  }

  // Lo demás que sirve al comercial va a las notas.
  const extra = [
    v['QUIERE FINANCIAR'] && `Quiere financiar: ${v['QUIERE FINANCIAR']}`,
    v['KILÓMETROS'] && `Km: ${v['KILÓMETROS']}`,
    v.PROCEDENCIA && `Procedencia: ${v.PROCEDENCIA}`,
    v['CONTACTO VÍA'] && `Contacto vía: ${v['CONTACTO VÍA']}`,
    v.AGENTE && `Agente CRM: ${v.AGENTE}`,
    v.SEDE && `Sede: ${v.SEDE}`
  ].filter(Boolean);
  if (extra.length) put('notes', extra.join(' · ').replace(/[<>]/g, ''));

  return { fields, found: Object.keys(fields), format: 'flexicar', warnings };
}

export function parseCrmText(raw) {
  if (isFlexicarLeadText(String(raw || ''))) return parseFlexicarLead(raw);
  const text = String(raw || '').replace(/\r/g, '').replace(/ /g, ' ');
  const fields = {};
  const rows = text.split('\n').map(l => l.trim()).filter(Boolean);

  // 1) Tablas: una fila de títulos (con tabuladores) seguida de una fila de valores con las mismas celdas.
  const used = new Set();
  for (let i = 0; i + 1 < rows.length; i++) {
    const head = rows[i].split('\t').map(c => c.trim());
    if (head.length < 2) continue;
    const keys = head.map(labelKey);
    if (keys.filter(Boolean).length < Math.max(2, Math.ceil(head.length / 2))) continue;
    const vals = rows[i + 1].split('\t').map(c => c.trim());
    if (vals.length !== head.length) continue;
    keys.forEach((k, j) => { if (k) putField(fields, k, vals[j]); });
    used.add(i); used.add(i + 1); i++;
  }

  // 2) Celdas sueltas: cada fila se parte por tabuladores (o "  " de varias columnas) en trozos.
  const lines = [];
  rows.forEach((r, i) => { if (!used.has(i)) r.split(/\t| {3,}/).map(c => c.trim()).filter(Boolean).forEach(c => lines.push(c)); });

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const m = line.match(/^([^:]{1,40}):\s*(.*)$/);
    if (m && !/^https?$/i.test(m[1].trim()) && labelKey(m[1])) {
      const key = labelKey(m[1]);
      let value = m[2];
      if (!value && i + 1 < lines.length && !labelKey(lines[i + 1].replace(/:.*$/, ''))) { value = lines[i + 1]; i++; }
      putField(fields, key, value);
      continue;
    }
    // Etiqueta sola en una línea y el valor en la siguiente.
    const key = labelKey(line.replace(/:$/, ''));
    if (key && i + 1 < lines.length && !labelKey(lines[i + 1].replace(/:.*$/, ''))) {
      if (putField(fields, key, lines[i + 1])) i++;
      continue;
    }
    // "Teléfono 600 123 456" (sin dos puntos): solo para datos con forma reconocible.
    const words = line.split(/\s+/);
    for (let n = Math.min(4, words.length - 1); n >= 1; n--) {
      const k = labelKey(words.slice(0, n).join(' '), true);
      const rest = words.slice(n).join(' ');
      if (k && TYPED_KEYS.includes(k)) { putField(fields, k, rest); break; }
      if (k && NO_COLON_TEXT_KEYS.includes(k) && !/\d|@/.test(rest) && rest.length <= 60) { putField(fields, k, rest); break; }
    }
  }

  // 3) Lo que no venía etiquetado, por su forma.
  if (!fields.email) { const e = text.match(EMAIL_RE); if (e) fields.email = e[0]; }
  if (!fields.phone) { const p = text.match(PHONE_RE); if (p) fields.phone = p[0].trim(); }
  if (!fields.vehicle_plate) { const p = text.match(PLATE_RE); if (p) fields.vehicle_plate = `${p[1]}${p[2].toUpperCase()}`; }
  if (fields.vehicle_price == null) { const p = text.match(PRICE_RE); if (p) { const n = parsePrice(p[0]); if (n != null) fields.vehicle_price = n; } }
  const urls = (text.match(new RegExp(URL_RE.source, 'gi')) || []).map(u => u.replace(/[).,;]+$/, ''));
  urls.forEach(u => {
    if (isWebAdUrl(u)) { if (!fields.vehicle_ref) fields.vehicle_ref = u; }
    else if (!fields.crm_url && u !== fields.vehicle_ref) fields.crm_url = u;
  });
  if (fields.crm_url && !fields.crm_lead_id) {
    const id = fields.crm_url.match(/(?:lead|leads|oportunidad|id)[/=](\d{3,})/i) || fields.crm_url.match(/\/(\d{4,})(?:[/?#]|$)/);
    if (id) fields.crm_lead_id = id[1];
  }

  return { fields, found: Object.keys(fields) };
}
